"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosHttpClient = void 0;
const axios_1 = require("axios");
class AxiosHttpClient {
    constructor() {
        this.axios = axios_1.default.create({});
    }
    async get(url) {
        return (await this.axios.get(url)).data;
    }
}
exports.AxiosHttpClient = AxiosHttpClient;
